
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/render/pageContent",
      function () {
        return require("private-next-pages/page/render/pageContent/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/render/pageContent"])
      });
    }
  